<template>
  <div style="margin: 15px 30px 0">
    <template v-if="active === 'apply'">
      <el-table :data="hosts" style="width: 100%" row-key="id">
        <el-table-column label="网站云">
          <template #default="scope">
            <el-link
              type="primary"
              style="margin-right: 5px"
              :underline="false"
              :href="getUrl(scope.row.hostName, scope.row.nodeName, scope.row.isHongKong)"
              target="_blank"
            >
              {{ getUniqueName(scope.row) }}
            </el-link>
            <br v-if="scope.row.nickName" />
            <el-link :underline="false" @click.prevent>
              {{ scope.row.nickName }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" label="版本" width="150">
          <template #default="scope">
            {{ getHostType(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建/到期时间" width="150">
          <template #default="scope">
            {{ scope.row.createdDate }}
            <br />
            {{ scope.row.expirationDate }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="可申请免费服务码数量" width="150">
          <template #default="scope">
            {{ scope.row.totalCount }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="已申请免费服务码数量" width="150">
          <template #default="scope">
            {{ scope.row.appliedCount }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="180">
          <template #default="scope">
            <el-button-group>
              <el-button :disabled="scope.row.totalCount <= scope.row.appliedCount" @click="btnHostClick(scope.row)">申请ICP备案服务码</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <el-divider></el-divider>

      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" @click.prevent="active = 'buy'">购买ICP备案服务码</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template v-else-if="active === 'applySuccess'">
        <div style="text-align: center">
          <h3 style="text-align: center; color: #67c23a">ICP备案服务码申请成功，我们将尽快发送给您！</h3>
          <el-button type="primary" v-on:click="btnCloseClick">关 闭</el-button>
        </div>
      </template>
    <template v-else-if="active === 'buy'">
      <el-form style="margin: 0 30px" label-position="top">
        <el-form-item label="费用合计">
          <span style="font-size: 18px; color: #fa5300">￥{{ getPayAmount().toFixed(2) }}</span>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer" style="text-align: center">
          <el-button type="primary" @click.prevent="btnPayClick">下一步</el-button>
        </div>
      </el-form>
    </template>
    <template v-else-if="active === 'pay'">
      <template v-if="payForm.isPurchased">
        <div style="text-align: center">
          <h3 style="text-align: center; color: #67c23a">ICP备案服务码购买成功，我们将尽快发送给您！</h3>
          <el-button type="primary" v-on:click="btnCloseClick">关 闭</el-button>
        </div>
      </template>
      <template v-else-if="payForm.isQrCode">
        <div style="text-align: center">
          <h3>打开手机{{ getChannel() }}，扫一扫下面的二维码，即可完成支付</h3>
          <div style="margin: 10px auto">
            <img v-if="payForm.channel == 'AliPay'" src="/home/img/channel_alipay.gif" />
            <img v-else src="/home/img/channel_weixin.gif" />
          </div>
          <canvas id="qrcode" style="margin: 0px auto; width: 260px; height: 260px"></canvas>
        </div>
      </template>
      <template v-else>
        <div style="margin-bottom: 10px; border: 1px solid #ebebeb; border-radius: 3px">
          <div style="padding: 24px">
            <h3 style="text-align: center; margin-bottom: 40px" v-html="getPayDescription()"></h3>

            <el-divider></el-divider>

            <div style="text-align: center">
              <div
                style="
                  width: 49%;
                  text-align: center;
                  border-right: 1px solid #eff2f6;
                  display: inline-block;
                  width: 49%;
                  box-sizing: border-box;
                  vertical-align: top;
                "
              >
                <span style="display: block; color: #8492a6; font-size: 14px; margin: 20px 0">
                  <img src="/home/img/channel_alipay.gif" />
                </span>
                <div class="el-image">
                  <el-button type="primary" v-on:click="btnPayChannelClick('AliPay')">使用支付宝支付</el-button>
                </div>
              </div>
              <div
                style="
                  width: 49%;
                  text-align: center;
                  display: inline-block;
                  width: 49%;
                  box-sizing: border-box;
                  vertical-align: top;
                "
              >
                <span style="display: block; color: #8492a6; font-size: 14px; margin: 20px 0">
                  <img src="/home/img/channel_weixin.gif" />
                </span>
                <div class="el-image">
                  <el-button type="primary" v-on:click="btnPayChannelClick('WxPay')">使用微信支付</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <p style="height: 30px"></p>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import api from '@/api/my/serviceCodes';
import utils from '@/utils';
import QRCode from 'qrcode';
import { IHost } from '@/types/models';

interface IPayForm {
  channel: string;
  isPurchased: boolean;
  isQrCode: boolean;
  orderNo: string;
  failureCount: 0;
}

interface IState {
  active: string;
  hosts: IHost[];
  price: number;
  payForm: IPayForm;
}

export default defineComponent({
  name: 'Buy',
  emits: ['close'],
  data() {
    return {
      active: 'apply',
      hosts: [],
      price: 0,
      payForm: {} as IPayForm,
    } as IState;
  },
  methods: {
    apiGet() {
      this.active = 'apply';
      this.hosts = [];
      this.price = 0;
      this.payForm = {} as IPayForm;

      api.buy((res) => {
        if (!res) return;
        this.hosts = res.hosts;
        this.price = res.price;
      });
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    getUniqueName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    getHostType(host: IHost) {
      return utils.getHostType(host.hostType);
    },

    getPayAmount(): number {
      return this.price;
    },

    getChannel() {
      return this.payForm.channel === 'AliPay' ? '支付宝' : '微信';
    },

    getPayDescription() {
      const amount = this.getPayAmount().toFixed(2);
      return `
        费用合计:
        <span style="color: #fa5300">￥${amount}</span>`;
    },

    payQuery() {
      const interval = setInterval(() => {
        api.query(
          {
            orderNo: this.payForm.orderNo,
          },
          (res) => {
            this.payForm.isPurchased = res.isPurchased;

            if (this.payForm.isPurchased) {
              clearInterval(interval);
            }
          },
        );
      }, 3000);
    },

    btnHostClick(host: IHost) {
      utils.alertDelete(
        {
          title: '申请ICP备案服务码',
          text: '此操作将申请ICP备案服务码，ICP备案服务码有效期为15天，确定吗？',
          button: '确定申请',
        },
        () => {
          api.apply({ hostId: host.id }, (res) => {
            if (res.value) {
              this.active = 'applySuccess';
            }
          });
        },
      );
    },

    btnPayChannelClick(channel: string) {
      this.payForm.channel = channel;

      api.pay(
        {
          channel: this.payForm.channel,
          amount: this.getPayAmount(),
        },
        (res) => {
          if (!res) return;

          this.payForm.isQrCode = true;
          this.payForm.orderNo = res.orderNo;

          setTimeout(() => {
            QRCode.toCanvas(document.getElementById('qrcode'), res.qrCodeUrl, { width: 260 });
          }, 100);

          this.payQuery();
        },
        (error) => {
          console.log(error);
          this.payForm.failureCount += 1;
          if (this.payForm.failureCount < 3) {
            this.btnPayChannelClick(channel);
          } else {
            utils.loading(false);
            utils.error(error);
          }
        },
      );
    },

    btnPayClick() {
      this.active = 'pay';
      this.payForm.failureCount = 0;
    },

    btnCloseClick() {
      this.$emit('close');
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
